<template>
  <app-content class="h-panel">
    <Loading text="数据加载中..." :loading="loading"></Loading>
    <div class="h-panel-bar">
      <span class="h-panel-title"><template v-if="report">{{report.name}}</template>&nbsp;</span>
      <!-- 新增导出按钮 -->
      <Button class="float-right" @click="exportExcel" :loading="exportLoading" style="margin-right: 10px;">导出Excel</Button>
      <Button class="float-right" @click="$router.back()">返回</Button>
    </div>
    <div class="margin-top margin-left margin-right">
      <account-date-choose v-model="accountDate"/>
      <router-link tag="button" class="h-btn float-right" v-if="User.role!=='View'" :to="{name:'TemplateForm',params:{templateId:reportId}}">编辑数据项</router-link>
    </div>
    <div class="h-panel-body">
      <Table class="small-td" :datas="templateItems" selectRow border v-if="report.type==0">
        <TableItem title="名称">
          <div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="本期金额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="本年累计金额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
      </Table>
      <Table class="small-td" :datas="templateItems" v-else-if="report.type == 2">
        <TableItem title="名称">
          <div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="本期金额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="本年累计金额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
      </Table>
      <Table :datas="templateItemsRender" selectRow border v-else-if="report.type == 1">
        <TableItem title="资产">
          <div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="期末余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="年初余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="负债和所有者权益">
          <div slot-scope="{data}" :class="{'font-bold':data.fs_isBolder}" :style="{paddingLeft:((data.fs_level-1)*15)+'px'}">{{data.fs_title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.fs_isClassified ? '':data.fs_lineNum>-1?data.fs_lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="期末余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.fs_id]?reportData[data.fs_id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="年初余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.fs_id]?reportData[data.fs_id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
      </Table>
    </div>
  </app-content>
</template>

<script>
import {mapState} from 'vuex'
// 引入xlsx库
import * as XLSX from 'xlsx'

export default {
  name: "ReportView.vue",
  props: {
    reportId: [Number, String]
  },
  data() {
    return {
      report: {},
      reportData: {},
      accountDate: null,
      loading: false,
      exportLoading: false // 导出按钮加载状态
    }
  },
  computed: {
    ...mapState(['User']),
    templateItems() {
      return this.report ? this.report.items : [];
    },
    templateItemsRender() {
      if (this.report.type === 1) {
        //所有资产
        let zc = this.templateItems.filter(function(val) { return val.type === 0; });
        let sq = this.templateItems.filter(function(val) { return val.type !== 0; });
        sq.forEach(function(val, index) {
          let changeObj = {
            fs_id: val.id,
            fs_lineNum: val.lineNum,
            fs_isBolder: val.isBolder,
            fs_level: val.level,
            fs_isClassified: val.isClassified,
            fs_title: val.title
          };
          if (zc[index]) {
            Object.assign(zc[index], changeObj);
          }
        });
        return zc;
      }
      return [];
    }
  },
  watch: {
    accountDate() {
      this.loadReport();
    },
    reportId() {
        this.loadReport();
    }
  },
  methods: {
    loadReport() {
      Api.report.template.load(this.reportId).then(function(res) {
        this.report = res.data;
        this.$nextTick(this.loadReportData);
      }.bind(this));
    },
    loadReportData() {
      this.loading = true;
      Api.report.view(this.reportId, {accountDate: this.accountDate}).then(function(res) {
        this.reportData = res.data;
      }.bind(this)).finally(function() {
        this.loading = false;
      }.bind(this));
    },
    // 核心导出Excel方法（彻底清除undefined）
    exportExcel() {
      // 数据未加载完成时拦截
      if (!this.report || !this.reportData) {
        this.$Message.warning('报表数据未加载完成，无法导出');
        return;
      }
      this.exportLoading = true;

      var excelData = []; // 最终导出的Excel数据
      var sheetName = this.report.name || '报表数据'; // Sheet名称
      var colWidths = []; // 列宽配置
      var _this = this; // 保存this指向，避免回调内this丢失

      // 处理3种报表类型
      switch (this.report.type) {
          // 类型0/2：利润表/现金流量表类（4列：名称、行次、本期金额、本年累计金额）
        case 0:
        case 2:
          // 1. 表头
          excelData.push(['名称', '行次', '本期金额', '本年累计金额']);
          // 2. 数据行（全字段兜底undefined）
          this.templateItems.forEach(function(item) {
            // 名称列：兜底undefined，按层级缩进
            var itemTitle = item.title || '';
            var nameIndent = '  '.repeat((item.level || 1) - 1);
            var name = nameIndent + itemTitle;

            // 行次列：完全匹配原页面逻辑，兜底undefined
            var lineNum = '';
            if (!item.isClassified && item.lineNum !== undefined && item.lineNum > -1) {
              lineNum = item.lineNum;
            }

            // 金额列：完全匹配原页面过滤器，undefined转为空字符串
            var currentAmount = '';
            var yearAmount = '';
            if (_this.reportData[item.id]) {
              currentAmount = _this.reportData[item.id].currentPeriodAmount || '';
              yearAmount = _this.reportData[item.id].currentYearAmount || '';
            }

            excelData.push([name, lineNum, currentAmount, yearAmount]);
          });
          // 3. 列宽配置
          colWidths = [
            { wch: 40 }, // 名称列
            { wch: 8 },  // 行次列
            { wch: 15 }, // 本期金额列
            { wch: 15 }  // 本年累计金额列
          ];
          break;

          // 类型1：资产负债表类（8列，左右双结构）
        case 1:
          // 1. 表头
          excelData.push(['资产', '行次', '期末余额', '年初余额', '负债和所有者权益', '行次', '期末余额', '年初余额']);
          // 2. 数据行（全字段兜底undefined）
          this.templateItemsRender.forEach(function(item) {
            // 左侧资产部分
            var zcTitle = item.title || '';
            var zcIndent = '  '.repeat((item.level || 1) - 1);
            var zcName = zcIndent + zcTitle;

            var zcLineNum = '';
            if (!item.isClassified && item.lineNum !== undefined && item.lineNum > -1) {
              zcLineNum = item.lineNum;
            }

            var zcEndAmount = '';
            var zcStartAmount = '';
            if (_this.reportData[item.id]) {
              zcEndAmount = _this.reportData[item.id].currentPeriodAmount || '';
              zcStartAmount = _this.reportData[item.id].currentYearAmount || '';
            }

            // 右侧负债和所有者权益部分
            var fzTitle = item.fs_title || '';
            var fzIndent = '  '.repeat((item.fs_level || 1) - 1);
            var fzName = fzIndent + fzTitle;

            var fzLineNum = '';
            if (!item.fs_isClassified && item.fs_lineNum !== undefined && item.fs_lineNum > -1) {
              fzLineNum = item.fs_lineNum;
            }

            var fzEndAmount = '';
            var fzStartAmount = '';
            if (_this.reportData[item.fs_id]) {
              fzEndAmount = _this.reportData[item.fs_id].currentPeriodAmount || '';
              fzStartAmount = _this.reportData[item.fs_id].currentYearAmount || '';
            }

            excelData.push([zcName, zcLineNum, zcEndAmount, zcStartAmount, fzName, fzLineNum, fzEndAmount, fzStartAmount]);
          });
          // 3. 列宽配置
          colWidths = [
            { wch: 35 }, // 资产列
            { wch: 8 },  // 资产行次列
            { wch: 15 }, // 资产期末余额列
            { wch: 15 }, // 资产年初余额列
            { wch: 35 }, // 负债和所有者权益列
            { wch: 8 },  // 负债行次列
            { wch: 15 }, // 负债期末余额列
            { wch: 15 }  // 负债年初余额列
          ];
          break;

        default:
          this.$Message.warning('不支持的报表类型，无法导出');
          this.exportLoading = false;
          return;
      }

      // 4. 创建Excel工作簿和Sheet
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(excelData);

      // 5. 配置列宽
      ws['!cols'] = colWidths;

      // 6. 配置表头样式（加粗）
      var headerRange = XLSX.utils.decode_range(ws['!ref']);
      for (var col = headerRange.s.c; col <= headerRange.e.c; col++) {
        var cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
        if (!ws[cellAddress]) continue;
        ws[cellAddress].s = {
          font: { bold: true, sz: 12 },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }

      // 7. 金额列设置数值格式（保留2位小数，千分位）
      var amountCols = this.report.type === 1 ? [2,3,6,7] : [2,3];
      for (var row = 1; row <= headerRange.e.r; row++) {
        amountCols.forEach(function(col) {
          var cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!ws[cellAddress]) return;
          // 空值单元格不设置数值格式，避免显示0
          if (ws[cellAddress].v === '') return;
          ws[cellAddress].s = {
            alignment: { horizontal: 'right', vertical: 'center' },
            numFmt: '#,##0.00' // 千分位+2位小数
          };
        });
      }

      // 8. 行次列居中对齐
      var lineNumCols = this.report.type === 1 ? [1,5] : [1];
      for (var row = 1; row <= headerRange.e.r; row++) {
        lineNumCols.forEach(function(col) {
          var cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!ws[cellAddress]) return;
          ws[cellAddress].s = {
            alignment: { horizontal: 'center', vertical: 'center' }
          };
        });
      }

      // 9. 名称列左对齐
      var nameCols = this.report.type === 1 ? [0,4] : [0];
      for (var row = 1; row <= headerRange.e.r; row++) {
        nameCols.forEach(function(col) {
          var cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!ws[cellAddress]) return;
          ws[cellAddress].s = {
            alignment: { horizontal: 'left', vertical: 'center' }
          };
        });
      }

      // 10. 冻结表头
      ws['!freeze'] = { xSplit: 0, ySplit: 1 };

      // 11. 写入Sheet并导出文件
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      var fileName = sheetName + '_' + (this.accountDate || '最新') + '.xlsx';
      XLSX.writeFile(wb, fileName);

      // 12. 导出完成
      this.exportLoading = false;
      this.$Message.success('Excel导出成功');
    }
  }
}
</script>

<style scoped>
div.font-bold {
  font-size: 14px;
}
</style>